export const ENGINE_OIL_VISCOSITIES = ['', '0W-12', '0W-16', '0W-20', '0W-30', '0W-40', '5W-20', '5W-30', '5W-40'];
export const ENGINE_OIL_VARIANTS = ['', 'FS', 'RC', 'C2', 'C3', 'C5', 'VR', 'HP', 'LL'];

export const buildEngineOilAttributes = ({ attributes = {}, sku = '', brand = '' }) => {
  const skuParts = String(sku).split('-');
  const skuVariant = skuParts[skuParts.length - 1];
  return {
    'Oil Type': attributes['Oil Type'] || (/^NORD KAPP$/i.test(brand) ? 'Full Synthetic' : ''),
    Viscosity: attributes.Viscosity || '',
    Variant: attributes.Variant || (ENGINE_OIL_VARIANTS.includes(skuVariant) ? skuVariant : ''),
    Volume: attributes.Volume || '',
    'Product Line': attributes['Product Line'] || '',
    API: attributes.API || '',
    ACEA: attributes.ACEA || '',
    ILSAC: attributes.ILSAC || '',
    'Fuel Application': attributes['Fuel Application'] || '',
    'OEM / Manufacturer Specifications': attributes['OEM / Manufacturer Specifications'] || '',
    Specifications: attributes.Specifications || '',
  };
};
